import { useDrop } from 'react-dnd'
import React from 'react'
import { Flex } from 'components/ds'
import { FILE, PLAYLIST, SECTION, TRACK } from '@disco/constants/ItemTypes'

type PlaylistCreatorDragOpenWrapperProps = {
  onDrag: () => void
  children?: React.ReactNode
}
const PlaylistCreatorDragOpenWrapper = ({
  onDrag,
  children,
}: PlaylistCreatorDragOpenWrapperProps) => {
  const [, dropRef] = useDrop({
    accept: [FILE, PLAYLIST, SECTION, TRACK],
    drop: () => {
      onDrag()
    },
    hover: (_, monitor) => {
      if (monitor.isOver({ shallow: true })) {
        onDrag()
      }
    },
    collect: monitor => ({
      isOverCurrent: monitor.isOver({ shallow: true }),
    }),
  })

  return (
    <Flex as="span" ref={dropRef}>
      {children}
    </Flex>
  )
}
export default PlaylistCreatorDragOpenWrapper
